export const headers = [
  { label: 'Model Name', key: 'file_name', show: true },
  { label: 'Last Modified', key: 'last_modified', show: true },
  { label: 'Status', key: 'status', show: true },
  { label: 'Company', key: 'owner', show: true,},
];

export const mmmRootParentPath = {
  name: 'All Marketing Mix Models',
  id: 0,
}